import Controller from "../../../../core/js/Controller";

export default class Sidebar extends Controller {
    constructor() {
        super();
    }

    afterInit() {
        if (!this.isEnabled()) {
            return;
        }

        setTimeout(function () {
            this.createSticky();
        }.bind(this), 300);

        window.addEventListener('resize', function (e) {
            this.refreshSidebar();
        }.bind(this))
    }

    isEnabled() {
        return false;
        if (document.body.offsetWidth < 800) {
            return false;
        }

        return document.querySelector('.content-wrapper').offsetHeight > this.content.offsetHeight + 200;
    }

    createSticky() {
        this.sidebar = new StickySidebar('#sidebar', {
            containerSelector: '#container',
            innerWrapperSelector: '.sidebar-content',
            topSpacing: 84,
            bottomSpacing: 0
        });
    }

    refreshSidebar() {
        if (this.sidebar) {
            this.sidebar.updateSticky();
        }
    }
}